import { useMutation } from '@tanstack/react-query';
import { useNavigate, useLocation } from 'react-router-dom';
import { authApi, type LoginPayload } from './authApi';
import { useSessionStore } from '../../stores/sessionStore';

export function useLogin() {
  const setSession = useSessionStore((state) => state.setSession);
  const navigate = useNavigate();
  const location = useLocation();

  return useMutation({
    mutationFn: (payload: LoginPayload) => authApi.login(payload),
    onSuccess: (session) => {
      setSession(session);
      const from = (location.state as any)?.from?.pathname;
      const search = (location.state as any)?.from?.search || '';
      const target = from && from !== '/login' ? `${from}${search}` : '/';
      navigate(target, { replace: true });
    },
  });
}

export function useLogout() {
  const clear = useSessionStore((state) => state.clear);
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      try {
        await authApi.logout();
      } finally {
        clear();
      }
    },
    onSuccess: () => {
      navigate('/login', { replace: true });
    },
  });
}
